import React, { Component } from 'react';
import { isEmpty, getModeIcon, getIcon } from '../../../Common/Common';

export default class Display_Conditions extends Component {
	constructor(props) {
		super(props);

		this.state = {
		}
	}

	handleEditInputCondition = (index) => {
		if (this.props.handleEditInputCondition != null) this.props.handleEditInputCondition(index)
	}

	render() {
		let style = {

		};
		// Handle weird span display padding top
		let is_show_paddingtop = false;
		if (this.props.program.condition.length > 0 || (this.props.program.condition.length == 1 && isEmpty(this.props.program.condition[0]))) {
			is_show_paddingtop = true;
		}

		return (
			<div style={style}>
				{this.props.program.condition.map((condition, index) => {
					if (condition.mp != null && !isEmpty(window.app.state.point_list[condition.mp])) {
						let name = window.app.state.point_list[condition.mp].name;
						let icon = getIcon(window.app.state.point_list[condition.mp].icon);
						let value_display = null;
						let point_info = null;

						switch (condition.type) {
							case 'error':
							case 'alert':
								// Tommy - 21/09/21 - Include true check for condition.value.fix
								if (condition.value.fix == 'true' || condition.value.fix) value_display = <span className='subtitle' style={{ fontSize: 14 }}>{this.props.receiver.getString('interlock_occur')}</span>
								else value_display = <span className='subtitle' style={{ fontSize: 14 }}>{this.props.receiver.getString('clear')}</span>
								break;
							case 'rt':
								if (condition.value.fix != null) {
									value_display = <span className='subtitle' style={{ fontSize: 14 }}>{condition.value.fix + this.props.receiver.getString('DEG')}</span>
								} else {
									// Tommy - 22/09/21 - Display mp name instead of point id
									point_info = window.app.state.point_list[condition.value.mp];
									let condiiton_label = condition.condition;
									value_display = <span className='subtitle' style={{ fontSize: 14 }}>{condiiton_label + ' ' + point_info.name + ' ' + this.props.receiver.getString('by') + ' ' + condition.value.ofset}</span>
								}
								break;
							case 'mode':
								value_display = <img src={getModeIcon(condition.value.fix)} style={{ width: 20, verticalAlign: 'bottom' }} />
								break;

							default:
								if (window.app.state.point_list[condition.mp].type == 'Occupied') {
									point_info = window.app.state.point_list[condition.mp];
									value_display = <span className='subtitle' style={{ fontSize: 14 }}>{this.props.receiver.getString(point_info.stat_word[condition.value.fix])}</span>
								} else if (condition.value.fix != null) {
									value_display = <span className='subtitle' style={{ fontSize: 14 }}>{condition.value.fix}</span>
								} else {
									let condiiton_label = condition.condition == '!=' ? '?' : condition.condition;
									// Tommy - 22/09/21 - Display mp name instead of point id
									point_info = window.app.state.point_list[condition.value.mp];
									value_display = <span className='subtitle' style={{ fontSize: 14 }}>{condiiton_label + ' ' + point_info.name + ' ' + this.props.receiver.getString('by') + ' ' + condition.value.ofset}</span>
								}
						}

						let condition_type_text;
						switch (window.app.state.point_list[condition.mp].type) {
							case 'Occupied':
							case 'Selection':
								condition_type_text = <span className='subtitle' style={{ fontSize: 14 }}>{this.props.receiver.getString('status')}</span>
								break;
							case 'Lock':
								condition_type_text = <span className='subtitle' style={{ fontSize: 14 }}>{this.props.receiver.getString('op')}</span>
								break;
							default:
								condition_type_text = <span className='subtitle' style={{ fontSize: 14 }}>{this.props.receiver.getString(condition.type)}</span>
								break;
						}


						return (
							<div style={{ cursor: 'pointer', backgroundColor: 'white', borderRadius: 20, width: this.props.width - 40 }} onClick={() => this.handleEditInputCondition(index)}>
								<div style={{ display: 'inline-block', marginLeft: 10, marginTop: 10, width: 30, marginRight: 5 }}>
									<img src={icon} style={{ width: 30 }} />
								</div>
								<div style={{ display: 'inline-block', width: this.props.width - 260, verticalAlign: 'top', paddingTop: 18 }}>
									<span>{name}</span>
								</div>
								<div id='display_fix' style={{ textAlign: 'right', verticalAlign: 'top', display: condition.value.fix != null ? 'inline-block' : 'none', width: 165 }}>
									<div style={{ display: 'inline-block', verticalAlign: 'top', paddingTop: 12 }}>
										{condition_type_text}
									</div>
									<div style={{ display: 'inline-block', marginLeft: 5, marginRight: 5, verticalAlign: 'top', paddingTop: 12 }}>
										<span className='subtitle' style={{ fontSize: 14 }}>{condition.condition == '!=' ? '≠' : condition.condition}</span>
									</div>
									<div style={{ display: 'inline-block', verticalAlign: 'top', paddingTop: 12 }}>
										{value_display}
									</div>
								</div>
								<div id='display_offset' style={{ textAlign: 'right', verticalAlign: 'top', display: condition.value.fix != null ? 'none' : 'inline-block', width: 165 }}>
									<div style={{ display: 'inline-block', verticalAlign: 'top', paddingTop: 12 }}>
										{value_display}
									</div>
								</div>
							</div>
						)
					} else {
						return null;
					}
				})}
			</div>
		)
	}
}